import { scoreboardNameFromPlayer } from "./playerDisplayName";

export const buildTeamListRows = (teams = []) =>
  teams.map((team) => ({
    id: team._id,
    teamName: team._id,
    playerCount: team.totalPlayers || 0,
    players: team.players || [],
  }));

export const buildTeamRosterRows = (players = []) =>
  players.map((player, index) => ({
    id: player.playerId || `player-${index}`,
    playerId: player.playerId,
    playerName: scoreboardNameFromPlayer(player),
  }));
